import './index.scss';
const PaymentRules = () => {
	return (
		<div className="paymentRules">
			<div className="content">
				{/* <div className="title">REGRAS DE PAGAMENTO ESTRELABET</div> */}
				<div className="textItem">
					<h1>REGRAS DE PAGAMENTO&nbsp;ESTRELABET</h1>
					<h4>FORMAS DE PAGAMENTOS</h4>
					<hr />
					&nbsp;
					<table>
						<thead>
							<tr>
								<th>Agencia Financiera</th>
								<th>Método de pago</th>
								<th>Taxa</th>
								<th>Prazo de Processamento</th>
								<th>Valor Mínimo</th>
								<th>Valor Máximo</th>
								<th>Informações</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Paybrokers</td>
								<td>Pix</td>
								<td>Gratuita</td>
								<td>Imediata</td>
								<td>R$1,00</td>
								<td>R$45.000,00</td>
								<td>Transferência bancária</td>
							</tr>
							<tr>
								<td>Pay2Free</td>
								<td>Pix</td>
								<td>Gratuita</td>
								<td>Imediata</td>
								<td>R$1,00</td>
								<td>R$45.000,00</td>
								<td>Transferência bancária</td>
							</tr>
						</tbody>
					</table>
					<h4>FORMAS DE SAQUE</h4>
					<hr />
					&nbsp;
					<table>
						<thead>
							<tr>
								<th>Agencia Financiera</th>
								<th>Método de pago</th>
								<th>Taxa</th>
								<th>Prazo de Processamento</th>
								<th>Valor Mínimo</th>
								<th>Valor Máximo por Transação</th>
								<th>Valor Máximo por Dia</th>
								<th>Informações</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Paybrokers</td>
								<td>Pix</td>
								<td>Gratuita</td>
								<td>Imediata</td>
								<td>R$0,01</td>
								<td>R$25.000,00</td>
								<td>R$45.000,00</td>
								<td>Transferência bancária</td>
							</tr>
							<tr>
								<td>Pay2Free</td>
								<td>Pix</td>
								<td>Gratuita</td>
								<td>Imediata</td>
								<td>R$0,01</td>
								<td>R$25.000,00</td>
								<td>R$50.000,00</td>
								<td>Transferência bancária</td>
							</tr>
						</tbody>
					</table>
					<h3>REGRAS DE DEPÓSITOS</h3>
					<hr /> &nbsp;
					<div>
						<h4>QUAL A REGRA SOBRE ONDE OS DEPÓSITOS PODEM SER FEITOS?</h4>

						<p>Depósitos podem ser realizados por qualquer instituição bancária.</p>
					</div>
					<div>
						<h4>POSSO DEPOSITAR POR CONTA BANCÁRIA DE PESSOA JURÍDICA?</h4>

						<p>
							Não é possível realizar depósitos na sua conta EstrelaBet por meio de contas de Pessoa
							Jurídica. Tentativa de depósitos serão devolvidas para conta de origem.
						</p>
					</div>
					<div>
						<h4>COMO FAÇO PARA DEPOSITAR VIA PIX?</h4>

						<p>
							Selecione PIX na lista de formas de pagamento disponíveis. Em seguida, será gerado o
							código QR que você poderá usar para fazer a leitura do pagamento PIX.
						</p>
					</div>
					<div>
						<h4>POSSO DEPOSITAR DE OUTRO BANCO?</h4>

						<p>
							Sim, pode depositar de qualquer banco, por ser uma forma de pagamento fornecida pelo
							Banco Central, você pode usar um banco diferente para realizar o pagamento.
						</p>
					</div>
					<div>
						<h4>QUAIS SÃO OS LIMITES MÍNIMO E MÁXIMO DE DEPÓSITO?</h4>

						<p>
							O limite mínimo é de R$1,00 (um real) e o máximo R$45.000,00(quarenta e cinco mil
							reais), para a PayBrokers.
							<br />
							O limite mínimo é de R$1,00 (um real) e o máximo R$45.000,00 (quarenta e cinco mil
							reais), para a Pay2Free
							<br />
							&nbsp;
						</p>
					</div>
					<div>
						<h4>EM QUANTO TEMPO O DINHEIRO CAI NA MINHA CONTA?</h4>

						<p>O dinheiro cai na conta automaticamente após fazer o pagamento.</p>

						<p>
							Importante: Em raríssimas ocasiões o seu depósito via pix pode sofrer um atraso de até
							2 (duas) horas. Esse atraso não vem da Estrelabet, vem da burocracia dos bancos e dos
							sistemas envolvidos. Estamos aqui para te dar todo o suporte necessário até que o seu
							depósito seja aprovado e enviado. Caso o problema persista após o período de 2 (duas)
							horas, favor entrar em contato com nossa equipe por meio do link&nbsp;&nbsp;
							<a href="https://www.mourgames.com/" target="_blank">
								https://www.mourgames.com
							</a>{' '}
							.
						</p>
					</div>
					<div>
						<h4>MEU DEPÓSITO VAI SER CREDITADO INSTANTANEAMENTE, MESMO NOS FINS DE SEMANA?</h4>

						<p>
							Sim, o dinheiro entra na sua conta durante os fins de semana. Basta fazer o PIX no
							valor exato informado em um prazo de até 3 (três) horas através do seu banco na
							internet.
						</p>
					</div>
					<div>
						<h4>
							FIZ UM PAGAMENTO PELO PIX, MAS NÃO GEREI O QR NO SITE, O QUE ACONTECE COM O MEU
							DEPÓSITO?
						</h4>

						<p>
							Para que seu depósito seja creditado em sua conta, você deve transferir desde seu
							banco online com o código QR gerado no site. Em caso de deposito incorreto, a
							devolução dos depósitos é realizada no prazo de 24 (vinte e quatro) a 48 (quarenta e
							oito) horas úteis. Entre em contato com a nossa Central de Atendimento ao Cliente com
							o comprovante de pagamento para que seu depósito seja devolvido para a conta de
							origem.
						</p>
					</div>
					<div>
						<h4>CASO TENHA FEITO UM DEPÓSITO INCORRETO, QUAL O PRAZO PARA ESTORNO?</h4>

						<p>
							O tempo de devolução dos depósitos é de 24 (vinte e quatro) a 48 (quarenta e oito)
							horas úteis, após o envio do comprovante e a confirmação dos dados para devolução.
						</p>
					</div>
					<div>
						<h4>É POSSÍVEL DEPOSITAR PELO CELULAR?</h4>

						<p>
							Sim, é possível. As formas de pagamento estão disponíveis para computador ou telefone
							celular.
						</p>
					</div>
					<h3>REGRAS DE SAQUE</h3>
					<hr />
					&nbsp;
					<div>
						<h4>
							<br />
							SOLICITEI UMA RETIRADA, MAS O VALOR AINDA NÃO FOI TRANSFERIDO.
						</h4>

						<p>
							Todas as retiradas são processadas e aprovadas pela nossa equipe de revisão interna e
							podem levar até 2 (dois) dias úteis a partir da solicitação.
						</p>
					</div>
					<div>
						<h4>
							SOLICITEI UMA RETIRADA, MAS MUDEI DE IDEIA E QUERO RETORNAR O DINHEIRO PARA A MINHA
							CONTA ESTRELABET.
						</h4>

						<p>
							Em casos excepcionais, ainda é possível cancelar a transação, dependendo do prazo
							restante para o processamento da retirada. Entre em contato com nossa equipe de
							suporte ao cliente indicando o motivo do cancelamento de sua retirada.
						</p>
					</div>
					<div>
						<h4>QUAL O LIMITE DE SAQUE?</h4>

						<p>
							Limite mínimo de R$0,01 (um centavo) para PayBrokers e R$0,01 (um centavo) para
							Pay2Free. Limite máximo por transação de R$25.000,00 (vinte e cinco mil reais) para
							PayBrokers e R$25.000,00 (vinte e cinco mil reais) por transação para Pay2Free. Limite
							máximo diário de R$50.000,00 (cinquenta mil reais) para Pay2Free e R$45.000,00
							(quarenta e cinco mil reais) para PayBrokers.
						</p>
					</div>
					<div>
						<h4>QUANTOS SAQUES EU POSSO FAZER?</h4>

						<p>
							É permitido a realização de 10 saques no período de 24 horas, sendo cada operação
							obedecendo este período. O montante máximo deverá ser de R$50.000,00 (cinquenta mil
							reais) na Pay2Free, e R$45.000,00 (quarenta e cinco mil reais) na PayBrokers.
						</p>
					</div>
					<div>
						<h4>HÁ ALGUM REQUISITO A SER CUMPRIDO ANTES DE FAZER UMA RETIRADA?</h4>

						<p>
							Se você recebeu dinheiro complementar ou bônus em sua conta, você deve cumprir com
							todas as condições de bônus contidas na oferta e / ou com os Termos e Condições Gerais
							de Bônus do site. Se você não cumprir essas condições, não poderá retirar qualquer
							montante até que todas as condições de bônus tenham sido atendidas.
						</p>
					</div>
					<div>
						<h4>COMO POSSO VERIFICAR O STATUS DA MINHA RETIRADA?</h4>

						<p>
							Faça login na sua conta e vá em configurações, selecione "Transações Financeiras" e,
							em seguida, clique em 'Saque' para verificar o status de cada retirada.
						</p>
					</div>
					<div>
						<h4>
							FIZ O MEU SAQUE E O DINHEIRO CAIU EM MINHA CONTA BANCÁRIA, LOGO EM SEGUIDA EFETUEI A
							DEVOLUÇÃO DO SAQUE, O QUE ACONTECE?
						</h4>

						<p>
							O tempo de devolução dos saques estornados é de 24 (vinte e quatro) a 48 (quarenta e
							oito) horas úteis, após o envio do comprovante e a confirmação dos dados para
							devolução.
						</p>
					</div>
					<div>
						<h4>INSTITUIÇÕES DE PAGAMENTO NÃO ACEITAS PARA SAQUES</h4>

						<p>
							Informamos que a EstrelaBet não permite a realização de saques para contas bancárias
							das referidas instituições:
						</p>
					</div>
					<table>
						<thead>
							<tr>
								<th>ISPB</th>
								<th>Banco</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>18189547</td>
								<td>CLOUDWALK IP LTDA – 6467</td>
							</tr>
							<tr>
								<td>40710595</td>
								<td>NG.CASH - 1682</td>
							</tr>
							<tr>
								<td>34006497</td>
								<td>ASTROPAY - 1634</td>
							</tr>
							<tr>
								<td>31818873</td>
								<td>QESH IP LTDA. - 956</td>
							</tr>
							<tr>
								<td>82065285</td>
								<td>COOP PARQ ARAUCARIAS PR/SC/SP - 375</td>
							</tr>
							<tr>
								<td>03816413</td>
								<td>PAGUEVELOZ IP LTDA. - 363</td>
							</tr>
							<tr>
								<td>45246410</td>
								<td>BANCO GENIAL - 353</td>
							</tr>
							<tr>
								<td>32024691</td>
								<td>DOTZPAY IP - 334</td>
							</tr>
							<tr>
								<td>22371651</td>
								<td>DMCARD - 298</td>
							</tr>
							<tr>
								<td>89049738</td>
								<td>COOPERATIVA DE CRÉDITO, POUPANÇA E INVESTIMENTO NOROESTE RS - 276</td>
							</tr>
							<tr>
								<td>32914717</td>
								<td>ONBANK IP SA - 218</td>
							</tr>
							<tr>
								<td>09515813</td>
								<td>ABASTECE AI IP LTDA. - 205</td>
							</tr>
							<tr>
								<td>38372267</td>
								<td>N/A - 192</td>
							</tr>
							<tr>
								<td>00655522</td>
								<td>APE POUPEX - 166</td>
							</tr>
							<tr>
								<td>10218474</td>
								<td>CIVIA COOP CRED - 161</td>
							</tr>
							<tr>
								<td>00556603</td>
								<td>BANCO BARI S.A. - 149</td>
							</tr>
							<tr>
								<td>13935893</td>
								<td>CELCOIN IP S.A. - 148</td>
							</tr>
							<tr>
								<td>11581339</td>
								<td>BMP SCMEPP LTDA - 142</td>
							</tr>
							<tr>
								<td>37880206</td>
								<td>CORA SCD S.A. - 141</td>
							</tr>
							<tr>
								<td>42898825</td>
								<td>CECM MEDICOS E PROFISSIONAIS AREA SAUDE DO BRASIL - 134</td>
							</tr>
							<tr>
								<td>19540550</td>
								<td>ASAAS IP S.A. - 133</td>
							</tr>
							<tr>
								<td>10311218</td>
								<td>COOP EVOLUA - 131</td>
							</tr>
							<tr>
								<td>33923798</td>
								<td>BANCO MASTER - 123</td>
							</tr>
							<tr>
								<td>79086997</td>
								<td>COOP SICREDI PARANAPANEMA SERRANA PR/SP/RJ - 122</td>
							</tr>
							<tr>
								<td>09512539</td>
								<td>CC DA FOZ DO RIO ITAJAÍ AÇU - 107</td>
							</tr>
							<tr>
								<td>16814330</td>
								<td>BK IP LTDA. - 101</td>
							</tr>
							<tr>
								<td>00971300</td>
								<td>COOP CRESOL PIONEIRA - 99</td>
							</tr>
							<tr>
								<td>85291086</td>
								<td>CC LITORÂNEA - 92</td>
							</tr>
							<tr>
								<td>25606237</td>
								<td>CPC VALE DO RIO DOCE - 92</td>
							</tr>
							<tr>
								<td>17351180</td>
								<td>BCO TRIANGULO S.A. - 89</td>
							</tr>
							<tr>
								<td>73647935</td>
								<td>COOP UNIQUE BR LTDA. - 86</td>
							</tr>
							<tr>
								<td>05277312</td>
								<td>COOP CRESOL HORIZONTE - 86</td>
							</tr>
							<tr>
								<td>39664698</td>
								<td>CREDSYSTEM SCD S.A. - 81</td>
							</tr>
							<tr>
								<td>17343510</td>
								<td>COOP CRESOL RAIZ - 79</td>
							</tr>
							<tr>
								<td>10520232</td>
								<td>COOP CRESOL AMAZONIA - 79</td>
							</tr>
							<tr>
								<td>10143743</td>
								<td>CREVISC - 78</td>
							</tr>
							<tr>
								<td>04902979</td>
								<td>BCO DA AMAZONIA S.A. - 78</td>
							</tr>
							<tr>
								<td>54037916</td>
								<td>CC CREDICITRUS - 77</td>
							</tr>
							<tr>
								<td>78862083</td>
								<td>COOP NOVOS CAMPOS - 75</td>
							</tr>
							<tr>
								<td>02910987</td>
								<td>COOP CRESOL CENTRO SUL RS/MS - 73</td>
							</tr>
							<tr>
								<td>05392810</td>
								<td>CC REGIÃO MERIDIONAL BRASIL - 69</td>
							</tr>
							<tr>
								<td>05888589</td>
								<td>COOP SUL - 67</td>
							</tr>
							<tr>
								<td>02282709</td>
								<td>COOP CENTRO NORTE BRASILEIRO - 67</td>
							</tr>
							<tr>
								<td>05425526</td>
								<td>COOP CRESOL DESENVOLVIMENTO - 67</td>
							</tr>
							<tr>
								<td>07512780</td>
								<td>COOP CRESOL VALE EUROPEU - 66</td>
							</tr>
							<tr>
								<td>80959612</td>
								<td>CC ALTO VALE DO ITAJAÍ - 65</td>
							</tr>
							<tr>
								<td>42873828</td>
								<td>CC AGROCREDI LTDA - 64</td>
							</tr>
							<tr>
								<td>25104230</td>
								<td>PAGARE IP S.A. - 64</td>
							</tr>
							<tr>
								<td>08075352</td>
								<td>COOP TRANSPOCRED - 63</td>
							</tr>
							<tr>
								<td>71243034</td>
								<td>COOPERATIVA DE CRÉDITO CREDIJEQUITINHONHA LTDA. - 60</td>
							</tr>
							<tr>
								<td>05667301</td>
								<td>CECM COOPERSERV - 57</td>
							</tr>
							<tr>
								<td>25395435</td>
								<td>CC CREDICAF LTDA - 54</td>
							</tr>
							<tr>
								<td>03485130</td>
								<td>COOP CRESOL ENCOSTAS DA SERRA GERAL - 51</td>
							</tr>
							<tr>
								<td>02446089</td>
								<td>COOP CRESOL UNIAO - 50</td>
							</tr>
							<tr>
								<td>05983995</td>
								<td>COOP CRESOL COOPERAR - 49</td>
							</tr>
							<tr>
								<td>05070112</td>
								<td>COOP CRESOL INOVAÇAO - 48</td>
							</tr>
							<tr>
								<td>07946451</td>
								<td>COOP CRESOL MEIO OESTE - 48</td>
							</tr>
							<tr>
								<td>05863726</td>
								<td>COOP CRESOL PLANALTO SERRA - 47</td>
							</tr>
							<tr>
								<td>05231945</td>
								<td>COOP CRESOL UNIAO DOS VALES - 47</td>
							</tr>
							<tr>
								<td>02663426</td>
								<td>COOP CRESOL NOROESTE - 45</td>
							</tr>
							<tr>
								<td>02405189</td>
								<td>COOP ÚNILOS - 45</td>
							</tr>
							<tr>
								<td>02448310</td>
								<td>COOP CRESOL PROGRESSO - 44</td>
							</tr>
							<tr>
								<td>26563270</td>
								<td>COOP DE PRIMAVERA DO LESTE - 43</td>
							</tr>
							<tr>
								<td>19449602</td>
								<td>CC CREDCOOPER LTDA - 42</td>
							</tr>
							<tr>
								<td>04565791</td>
								<td>COOP CRESOL ARATIBA - 42</td>
							</tr>
							<tr>
								<td>09313766</td>
								<td>CARUANA SCFI - 40</td>
							</tr>
							<tr>
								<td>03461243</td>
								<td>CC DO NORTE CATARINENSE - 39</td>
							</tr>
							<tr>
								<td>00966246</td>
								<td>CC CREDICERIPA - 39</td>
							</tr>
							<tr>
								<td>04261151</td>
								<td>COOP CRESOL TRANSFORMAÇÃO - 39</td>
							</tr>
							<tr>
								<td>65229254</td>
								<td>CC COOPACREDI - 38</td>
							</tr>
							<tr>
								<td>07925729</td>
								<td>COOP CRESOL NORTE PARANAENSE - 37</td>
							</tr>
							<tr>
								<td>81011686</td>
								<td>CC DO NORTE CATARINENSE E SUL PARANAENSE - 36</td>
							</tr>
							<tr>
								<td>03985375</td>
								<td>CREDISIS SUDOESTE/RO - 36</td>
							</tr>
							<tr>
								<td>04694278</td>
								<td>CECM INTEG. MF DP ESTADO RJ - 36</td>
							</tr>
							<tr>
								<td>22724710</td>
								<td>CC CREDIVERTENTES - 35</td>
							</tr>
							<tr>
								<td>03612764</td>
								<td>COOP FRONTEIRAS - 35</td>
							</tr>
							<tr>
								<td>05276770</td>
								<td>COOP CRESOL FRONTEIRAS PR/SC/SP/ES - 34</td>
							</tr>
							<tr>
								<td>02904125</td>
								<td>COOP CRESOL JACUTINGA - 33</td>
							</tr>
							<tr>
								<td>05410056</td>
								<td>COOP CRESOL LITORAL - 33</td>
							</tr>
							<tr>
								<td>07318874</td>
								<td>N/A - 32</td>
							</tr>
							<tr>
								<td>03222753</td>
								<td>CREDISIS CREDIARI COOP LTDA. - 31</td>
							</tr>
							<tr>
								<td>20757199</td>
								<td>N/A - 31</td>
							</tr>
							<tr>
								<td>73750424</td>
								<td>CECM UNICRED INTEGRAÇÃO - 30</td>
							</tr>
							<tr>
								<td>05211129</td>
								<td>COOP CRESOL CENTRO NORTE - 30</td>
							</tr>
							<tr>
								<td>25528753</td>
								<td>C.C CREDIVERDE - 29</td>
							</tr>
							<tr>
								<td>25387671</td>
								<td>CC ALTO PARANAIBA E REGIÃO - 29</td>
							</tr>
							<tr>
								<td>72257793</td>
								<td>SICREDI CEARÁ - 29</td>
							</tr>
							<tr>
								<td>22656789</td>
								<td>CC CREDISUDESTE LTDA - 28</td>
							</tr>
							<tr>
								<td>08624548</td>
								<td>COOP CRESOL MINAS GERAIS - 28</td>
							</tr>
							<tr>
								<td>05220243</td>
								<td>COOP CRESOL ORIGENS - 28</td>
							</tr>
							<tr>
								<td>92874270</td>
								<td>BCO DIGIMAIS S.A. - 27</td>
							</tr>
							<tr>
								<td>21670187</td>
								<td>CC CREDIBOM - 27</td>
							</tr>
							<tr>
								<td>05494591</td>
								<td>COOP CRESOL NASCENTE - 27</td>
							</tr>
							<tr>
								<td>02766672</td>
								<td>COOP CRESOL PLANALTO SUL - 27</td>
							</tr>
							<tr>
								<td>39576810</td>
								<td>N/A - 25</td>
							</tr>
							<tr>
								<td>00707903</td>
								<td>CC VALE DO CANOAS - 24</td>
							</tr>
							<tr>
								<td>04350225</td>
								<td>COOP CRESOL TRADICAO - 24</td>
							</tr>
							<tr>
								<td>54190525</td>
								<td>CECM SERV MUN REG METR VALE PARAIBA E LITORAL NORTE - 24</td>
							</tr>
							<tr>
								<td>64237530</td>
								<td>CC CREDIUNA LTDA - 23</td>
							</tr>
							<tr>
								<td>08560508</td>
								<td>COOP CRESOL TRIUNFO - 23</td>
							</tr>
							<tr>
								<td>02934201</td>
								<td>COOP CRESOL LIDERANCA - 22</td>
							</tr>
							<tr>
								<td>35534511</td>
								<td>A27 IP S/A - 22</td>
							</tr>
							<tr>
								<td>07268499</td>
								<td>COOP CRESOL INTEGRACAO - 22</td>
							</tr>
							<tr>
								<td>26178111</td>
								<td>CC UNIÃO CENTRO OESTE LTDA - 22</td>
							</tr>
							<tr>
								<td>49389307</td>
								<td>CC COOPLIVRE - 21</td>
							</tr>
							<tr>
								<td>05269976</td>
								<td>COOP CRESOL MAIS - 21</td>
							</tr>
							<tr>
								<td>01062439</td>
								<td>CECM DOS FUNCIONARIOS DA COMIGO - 21</td>
							</tr>
							<tr>
								<td>71027866</td>
								<td>BCO BS2 S.A. - 20</td>
							</tr>
							<tr>
								<td>33370115</td>
								<td>FURNAS - 20</td>
							</tr>
							<tr>
								<td>03965737</td>
								<td>COOP CRESOL VANGUARDA - 20</td>
							</tr>
							<tr>
								<td>24431221</td>
								<td>COOP CRESOL TRANSAMAZÔNICA - 20</td>
							</tr>
							<tr>
								<td>22749014</td>
								<td>CC REGIÃO CENTRAL MG - 20</td>
							</tr>
							<tr>
								<td>21866694</td>
								<td>CC CREDINOR – 19</td>
							</tr>
							<tr>
								<td>67960229</td>
								<td>CC CREDIGUAÇU - 19</td>
							</tr>
							<tr>
								<td>07252614</td>
								<td>COOP CRESOL CONFIANÇA - 18</td>
							</tr>
							<tr>
								<td>11969853</td>
								<td>COOP CRESOL CONEXÃO - 18</td>
							</tr>
							<tr>
								<td>69346856</td>
								<td>CECM DOS PROFISSIONAIS DA SAUDE DA REG ALTA MOGIANA - 18</td>
							</tr>
							<tr>
								<td>09330158</td>
								<td>COOP CRESOL TREZE DE MAIO - 17</td>
							</tr>
							<tr>
								<td>07509426</td>
								<td>COOP CRESOL XANXERE - 17</td>
							</tr>
							<tr>
								<td>62232889</td>
								<td>BCO DAYCOVAL S.A - 16</td>
							</tr>
							<tr>
								<td>66398496</td>
								<td>CC CREDIARA LTDA. - 16</td>
							</tr>
							<tr>
								<td>07215632</td>
								<td>COOP CRESOL ALTERNATIVA - 16</td>
							</tr>
							<tr>
								<td>01705236</td>
								<td>UNICRED PROSPERAR - 16</td>
							</tr>
							<tr>
								<td>11970623</td>
								<td>BCO SENFF S.A. - 15</td>
							</tr>
							<tr>
								<td>24048910</td>
								<td>CC CREDINTER - 15</td>
							</tr>
							<tr>
								<td>00429890</td>
								<td>CC CREDIAGRO - 15</td>
							</tr>
							<tr>
								<td>21661202</td>
								<td>CC CREDICAMPO LTDA - 15</td>
							</tr>
							<tr>
								<td>28505126</td>
								<td>LOGBANK IP S.A. - 15</td>
							</tr>
							<tr>
								<td>05351887</td>
								<td>ZEMA CFI S/A - 15</td>
							</tr>
							<tr>
								<td>02398976</td>
								<td>SISPRIME DO BRASIL - COOP - 15</td>
							</tr>
							<tr>
								<td>19468242</td>
								<td>ZOOP MEIOS DE PAGAMENTO - 14</td>
							</tr>
							<tr>
								<td>68900810</td>
								<td>BCO RENDIMENTO S.A. - 14</td>
							</tr>
							<tr>
								<td>09463721</td>
								<td>COOP CRESOL JACINTO MACHADO - 14</td>
							</tr>
							<tr>
								<td>09552111</td>
								<td>CC JUST GOIAS E CELG - 13</td>
							</tr>
							<tr>
								<td>30980539</td>
								<td>U4C INSTITUIÇÃO DE PAGAMENTO S.A. - 13</td>
							</tr>
							<tr>
								<td>01152097</td>
								<td>CC CREDIMATA - 13</td>
							</tr>
							<tr>
								<td>00698609</td>
								<td>CC NORTE E NOROESTE DE MINAS GERAIS - 13</td>
							</tr>
							<tr>
								<td>94433109</td>
								<td>CECM MÉD DE PORTO ALEGRE - 13</td>
							</tr>
							<tr>
								<td>02641032</td>
								<td>UNICRED PONTO CAPITAL - 13</td>
							</tr>
							<tr>
								<td>06126780</td>
								<td>COOP CRESOL GRANDES LAGOS PR/SP - 12</td>
							</tr>
							<tr>
								<td>01187961</td>
								<td>CC DISTRITO FEDERAL E ENTORNO - 12</td>
							</tr>
							<tr>
								<td>08055016</td>
								<td>COOP CRESOL INTERAÇÃO - 12</td>
							</tr>
							<tr>
								<td>38588174</td>
								<td>CC CREDICOPE - 12</td>
							</tr>
							<tr>
								<td>23114447</td>
								<td>FLAGSHIP IP LTDA - 12</td>
							</tr>
							<tr>
								<td>05241145</td>
								<td>COOP CRESOL GETULIO VARGAS - 12</td>
							</tr>
							<tr>
								<td>44469161</td>
								<td>COOPECREDI GUARIBA - CC - 12</td>
							</tr>
							<tr>
								<td>01073966</td>
								<td>CCR DE ABELARDO LUZ - 11</td>
							</tr>
							<tr>
								<td>11760553</td>
								<td>GAZINCRED S.A. SCFI - 11</td>
							</tr>
							<tr>
								<td>00068987</td>
								<td>CC ARACREDI LTDA. - 11</td>
							</tr>
							<tr>
								<td>17361536</td>
								<td>CC REG. COLAR METROPOLITANO VALE DO AÇO LTDA - 11</td>
							</tr>
							<tr>
								<td>01608685</td>
								<td>COOP DO ESTADO DO ACRE LTDA. - 11</td>
							</tr>
							<tr>
								<td>66788142</td>
								<td>CC CREDIMOTA - 10</td>
							</tr>
							<tr>
								<td>71154256</td>
								<td>CC SACRAMENTO - 10</td>
							</tr>
							<tr>
								<td>65239402</td>
								<td>CC UNIÃO DO CENTRO OESTE DE MINAS - 10</td>
							</tr>
							<tr>
								<td>17079937</td>
								<td>PINBANK IP - 10</td>
							</tr>
							<tr>
								<td>02883398</td>
								<td>CC VALE ITAJAÍ E ITAPOCÚ - 10</td>
							</tr>
							<tr>
								<td>03015152</td>
								<td>COOP CRESOL SÃO VALENTIM - 10</td>
							</tr>
							<tr>
								<td>04414354</td>
								<td>CCM DO ABC - COOPER 7 - 10</td>
							</tr>
							<tr>
								<td>31752308</td>
								<td>PHI PAGAMENTOS - 9</td>
							</tr>
							<tr>
								<td>07494300</td>
								<td>CREDISIS/CREDISUL COOPERATIVA DE CRÉDITO - 9</td>
							</tr>
							<tr>
								<td>07320890</td>
								<td>COOP CRESOL VALE - 9</td>
							</tr>
							<tr>
								<td>05979692</td>
								<td>CREDCREA - 9</td>
							</tr>
							<tr>
								<td>09488496</td>
								<td>COOP CRESOL SAO JOAO DO SUL - 9</td>
							</tr>
							<tr>
								<td>01330387</td>
								<td>COOP DE AGRICULTORES E AEROPORTUÁRIOS DO BRASIL - 9</td>
							</tr>
							<tr>
								<td>68969625</td>
								<td>CECM EMP USAGRO - 8</td>
							</tr>
							<tr>
								<td>03033469</td>
								<td>CC DO PLANALTO SUL - 8</td>
							</tr>
							<tr>
								<td>09590601</td>
								<td>CC DA SERRA CATARINENSE - 8</td>
							</tr>
							<tr>
								<td>04663561</td>
								<td>COOP INVEST INT SOL VALE DAS ÁGUAS PR/MG - 8</td>
							</tr>
							<tr>
								<td>17502881</td>
								<td>CECM EMPR CEMIG IND METAL E SERV PUB MUN - 8</td>
							</tr>
							<tr>
								<td>89280960</td>
								<td>CECM DOS EMPR DAS EMP RANDON - 8</td>
							</tr>
							<tr>
								<td>67096909</td>
								<td>CC CREDICOCAPEC - 7</td>
							</tr>
							<tr>
								<td>97489280</td>
								<td>COOP SICREDI INTEGRAÇÃO BAHIA - 7</td>
							</tr>
							<tr>
								<td>25798596</td>
								<td>CC CREDIVAR - 7</td>
							</tr>
							<tr>
								<td>08488377</td>
								<td>COOP CRESOL MISSÕES FRONTEIRA RS - 7</td>
							</tr>
							<tr>
								<td>35136120</td>
								<td>N/A - 7</td>
							</tr>
							<tr>
								<td>95163002</td>
								<td>UNICRED ELEVA - 7</td>
							</tr>
							<tr>
								<td>03412878</td>
								<td>CC CREDIRAMA - 7</td>
							</tr>
							<tr>
								<td>00075847</td>
								<td>CC UNICRED CENTRO-SUL LTDA - UNICRED CENTRO-SUL - 6</td>
							</tr>
							<tr>
								<td>07958405</td>
								<td>COOP CRESOL SERRA MAR - 6</td>
							</tr>
							<tr>
								<td>41255225</td>
								<td>COOP SICREDI CENT PERNAMBUCANA - 6</td>
							</tr>
							<tr>
								<td>04406371</td>
								<td>COOP DO ESTADO DE GOIÁS - 6</td>
							</tr>
							<tr>
								<td>86564051</td>
								<td>CC NOROESTE DE MINAS - 6</td>
							</tr>
							<tr>
								<td>06139650</td>
								<td>COOP CRESOL RIO GRANDE DO SUL - 5</td>
							</tr>
							<tr>
								<td>34088029</td>
								<td>LISTO SCD S.A. - 5</td>
							</tr>
							<tr>
								<td>39231527</td>
								<td>UNICRED COSTA DO SOL RJ - 5</td>
							</tr>
							<tr>
								<td>07714057</td>
								<td>CECM PROF ÁREA NOTARIAL REGISTRAL - 5</td>
							</tr>
							<tr>
								<td>08850613</td>
								<td>CECM EMPR CENT ELÉTRICAS/SC - 5</td>
							</tr>
							<tr>
								<td>04490531</td>
								<td>COOP CRESOL GOIAS - 5</td>
							</tr>
							<tr>
								<td>25536764</td>
								<td>CC CREDPLUS - 4</td>
							</tr>
							<tr>
								<td>04307598</td>
								<td>FIDUCIA SCMEPP LTDA - 4</td>
							</tr>
							<tr>
								<td>71238232</td>
								<td>CC CENTRO SUL MINEIRO - 4</td>
							</tr>
							<tr>
								<td>03419786</td>
								<td>CC NOSSA SENHORA DO DESTERRO - 4</td>
							</tr>
							<tr>
								<td>00714671</td>
								<td>EWALLY IP S.A. - 4</td>
							</tr>
							<tr>
								<td>60850229</td>
								<td>OMNI BANCO S.A. - 4</td>
							</tr>
							<tr>
								<td>48176336</td>
								<td>N/A - 4</td>
							</tr>
							<tr>
								<td>03102185</td>
								<td>CC DOS SERVIDORES, EMPRESARIOS, AUTONOMOS E LIBERAIS - 3</td>
							</tr>
							<tr>
								<td>71418784</td>
								<td>CC PROF SAÚDE E LA DO SUL DE MINAS LTDA. - 3</td>
							</tr>
							<tr>
								<td>07070495</td>
								<td>COOP SICREDI EMPREENDEDORES - 3</td>
							</tr>
							<tr>
								<td>06031727</td>
								<td>COOP CRESOL ESSENCIA - 3</td>
							</tr>
							<tr>
								<td>27084098</td>
								<td>TRANSFEERA IP S.A. - 3</td>
							</tr>
							<tr>
								<td>02000895</td>
								<td>CECM SERV POD JUD TCE ORG PUBL MUN EST FED RJ - 3</td>
							</tr>
							<tr>
								<td>32192325</td>
								<td>UZZIPAY IP S.A. - 3</td>
							</tr>
							<tr>
								<td>01155801</td>
								<td>COOP CRESOL CENTRO SERRA - 3</td>
							</tr>
							<tr>
								<td>23949522</td>
								<td>CC CREDICARPA - 2</td>
							</tr>
							<tr>
								<td>22760839</td>
								<td>CC NOSSOCREDITO - 2</td>
							</tr>
							<tr>
								<td>02844024</td>
								<td>COOP CRESOL EVOLUÇAO - 2</td>
							</tr>
							<tr>
								<td>41931445</td>
								<td>CC CREDIFOR LTDA - 2</td>
							</tr>
							<tr>
								<td>04572960</td>
								<td>CECM MILITARES ESTADUAIS DE SC - 2</td>
							</tr>
							<tr>
								<td>60779196</td>
								<td>CREFISA S.A. CFI - 2</td>
							</tr>
							<tr>
								<td>01864151</td>
								<td>CECM SERV E EMPREG PUBL MUN BH BETIM BRUMAD CONTAG IBI NL RN - 2</td>
							</tr>
							<tr>
								<td>01090027</td>
								<td>CECMM CATEG AFINS-UNICRED MÚLTIPLO VALOR - 2</td>
							</tr>
							<tr>
								<td>36900256</td>
								<td>CCM MED EMP MT - 2</td>
							</tr>
							<tr>
								<td>05861932</td>
								<td>CCM DOS ADVOGADOS DE SC - 2</td>
							</tr>
							<tr>
								<td>02179673</td>
								<td>CECM MÉD OURINHOS - 2</td>
							</tr>
							<tr>
								<td>38320462</td>
								<td>N/A - 2</td>
							</tr>
							<tr>
								<td>27214112</td>
								<td>AL5 S.A. CFI - 2</td>
							</tr>
							<tr>
								<td>19402130</td>
								<td>CECM EMPR EST HOSP BH RM ZM - 2</td>
							</tr>
							<tr>
								<td>05938780</td>
								<td>COOPER CARD IP - 2</td>
							</tr>
							<tr>
								<td>02904138</td>
								<td>COOP CRESOL ÁUREA - 2</td>
							</tr>
							<tr>
								<td>50735161</td>
								<td>COOP CRESOL MATO GROSSO - 2</td>
							</tr>
							<tr>
								<td>23273917</td>
								<td>VALLOO PAGAMENTOS - 2</td>
							</tr>
							<tr>
								<td>26014175</td>
								<td>CC GUARANICREDI - 1</td>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<td>03645752</td>
								<td>CC CREDISG</td>
							</tr>
							<tr>
								<td>03662047</td>
								<td>COOP SICREDI MP</td>
							</tr>
							<tr>
								<td>03047549</td>
								<td>CC CAP UNICIDADES</td>
							</tr>
							<tr>
								<td>21332862</td>
								<td>CARTOS SCD S.A.</td>
							</tr>
							<tr>
								<td>08030602</td>
								<td>CCM CORRET SEG EST SAO PAULO</td>
							</tr>
							<tr>
								<td>53623781</td>
								<td>CC COOPCRED</td>
							</tr>
							<tr>
								<td>21995256</td>
								<td>MAG IP LTDA.</td>
							</tr>
							<tr>
								<td>01039011</td>
								<td>CC UNICRED DESBRAVADORA LTDA - UNICRED DESBRAVADORA</td>
							</tr>
							<tr>
								<td>76461557</td>
								<td>CCR COOPAVEL</td>
							</tr>
							<tr>
								<td>04985665</td>
								<td>CREDISIS OESTE - CCI DO OESTE</td>
							</tr>
							<tr>
								<td>71163315</td>
								<td>UNICRED AMPLA</td>
							</tr>
							<tr>
								<td>66259110</td>
								<td>CC CREDIBAM LTDA.</td>
							</tr>
							<tr>
								<td>31680151</td>
								<td>SWAP MP IP SA</td>
							</tr>
							<tr>
								<td>01635462</td>
								<td>CECM DOS MÉDICOS DOS V TAQUARI E RIO PARDO E REG PRO</td>
							</tr>
							<tr>
								<td>81723108</td>
								<td>CREDICOAMO</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	);
};
export default PaymentRules;
